// Same PDF hosted as two S3 objects with different Content-Disposition headers:
// - challengeGuideLink: inline (opens in browser tab)
// - challengeGuideDownloadLink: attachment (forces file download)
// This is needed because the <a download> attribute is ignored for cross-origin URLs.
export const challengeGuideLink =
  'https://content.lifebase.solutions/challenges/SWYMO_Challenge_Creation_Checklist.pdf';

export const challengeGuideDownloadLink =
  'https://content.lifebase.solutions/challenges/SWYMO_Challenge_Creation_Checklist_Download.pdf';

// Embedded on the Training Calendar page (iframe)
export const trainingCalendarLink =
  'https://widgets.commoninja.com/iframe/bcf39fc1-862a-429e-aab5-2c1dae707f24';
